const facadeURL = process.env.REACT_APP_FACADE_URL  ?? ''
const bucketName = 'alpha-pg3-gcs-facade'

const buildFacadeFileUrl = (base: string, folder: string, fileName: string): string => {
  const encodedPath = `tips-and-tricks%2F${encodeURIComponent(folder)}%2F${encodeURIComponent(fileName)}`
  return `${base}/${bucketName}/${encodedPath}`
}

export const workfrontBasicsDocuments = [
  {
    phase: 'Project and Resource Management',
    documentName: 'I want to connect Workfront to The Playground',
    fileType: 'PDF',
    roles: ['All Roles'],
    prodUrl: 'https://cokeurl.com/wf-connect-wf-to-pg',
    stageUrl: 'https://cokeurl.com/Swf-connect-wf-to-pg',
  },
  {
    phase: 'Task Management',
    documentName: 'I want to change the project status to planning before updating tasks',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/wf-change-prj-status',
    stageUrl: 'https://cokeurl.com/Swf-change-prj-statu',
  },
  {
    phase: 'Project and Resource Management',
    documentName: 'I want to staff or bulk assign resources',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/wf-bulk-assign',
    stageUrl: 'https://cokeurl.com/Swf-bulk-assign',
  },
  {
    phase: 'Project and Resource Management',
    documentName: 'I want to add additional OU or Market Level projects',
    fileType: 'PDF',
    roles: ['Project Lead'],
    url: buildFacadeFileUrl(facadeURL, 'workfront', 'WF - I want to add additional OU or Market Level projects.pdf'),
  },
  {
    phase: 'Project and Resource Management',
    documentName: 'I want to customize widgets on the Home page',
    fileType: 'PDF',
    roles: ['All Roles'],
    prodUrl: 'https://cokeurl.com/wf-customize-widgets',
    stageUrl: 'https://cokeurl.com/Swf-customize-widget',
  },
  {
    phase: 'Task Management',
    documentName: 'I want to add, rearrange or skip a task in a project',
    fileType: 'PDF',
    roles: ['Project Lead'],
    url: buildFacadeFileUrl(facadeURL, 'workfront', 'WF - I want to add, rearrange or skip a task in a project.pdf'),
  },
  {
    phase: 'Task Management',
    documentName: 'I want to reassign a task to another user',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/wf-reassign-tasks',
    stageUrl: 'https://cokeurl.com/Swf-reassign-tasks',
  },
  {
    phase: 'Task Management',
    documentName: 'I want to update the due date of a task',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/wf-change-due-dates',
    stageUrl: 'https://cokeurl.com/Swf-change-due-dates',
  },
  {
    phase: 'Task Management',
    documentName: 'I want to mark a task as complete',
    fileType: 'PDF',
    roles: ['All Roles'],
    prodUrl: 'https://cokeurl.com/wf-complete-a-task',
    stageUrl: 'https://cokeurl.com/Swf-complete-a-task',
  },
]

export const experienceLoopDocuments = [
  {
    phase: 'Project Request',
    documentName: 'I want to create an Experience Loop project',
    fileType: 'PDF',
    roles: ['All Roles'],
    prodUrl: 'https://cokeurl.com/xl-create-xl-project',
    stageUrl: 'https://cokeurl.com/Sxl-create-xl-projec',
  },
  {
    phase: 'Project Request',
    documentName: 'I want to create a Single Market Experience Loop Project',
    fileType: 'PDF',
    roles: ['All Roles'],
    prodUrl: 'https://cokeurl.com/xl-creat-single-proj',
    stageUrl: 'https://cokeurl.com/Sxl-creat-single-pro',
  },
  {
    phase: 'Prioritization',
    documentName: 'I want to complete Unified Prioritization Form Experience Loop project',
    fileType: 'PDF',
    roles: ['Project Owner'],
    prodUrl: 'https://cokeurl.com/xl-complete-uni-form',
    stageUrl: 'https://cokeurl.com/Sxl-complete-uni-for',
  },
  {
    phase: 'Prioritization',
    documentName: 'I want to get Impact & Effort for Prioritization for Experience Loop',
    fileType: 'PDF',
    roles: ['Project Owner', 'Technical Lead'],
    prodUrl: 'https://cokeurl.com/xl-get-effort-impact',
    stageUrl: 'https://cokeurl.com/Sxl-get-effort-impac',
  },
  {
    phase: 'Prioritization',
    documentName: 'I want to do Prioritization & Approval for Experience Loop',
    fileType: 'PDF',
    roles: ['Project Owner', 'Technical Lead'],
    prodUrl: 'https://cokeurl.com/xl-priorit-approval',
    stageUrl: 'https://cokeurl.com/Sxl-priorit-approval',
  },
  {
    phase: 'Assemble',
    documentName: 'I want to assign the Project Sponsor',
    fileType: 'PDF',
    roles: ['Project Owner'],
    prodUrl: 'https://cokeurl.com/xl-assign-sponsor',
    stageUrl: 'https://cokeurl.com/Sxl-assign-sponsor',
  },
  {
    phase: 'Assemble',
    documentName: 'I want to assign the Project Lead',
    fileType: 'PDF',
    roles: ['Project Owner'],
    prodUrl: 'https://cokeurl.com/xl-assign-proj-lead',
    stageUrl: 'https://cokeurl.com/Sxl-assign-proj-lead',
  },
  {
    phase: 'Assemble',
    documentName: 'I want to assign the budget',
    fileType: 'PDF',
    roles: ['Project Owner'],
    prodUrl: 'https://cokeurl.com/xl-assign-budget',
    stageUrl: 'https://cokeurl.com/Sxl-assign-budget',
  },
  {
    phase: 'Assemble',
    documentName: 'I want to update the project',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-update-wf-project',
    stageUrl: 'https://cokeurl.com/Sxl-update-wf-projec',
  },
  {
    phase: 'Assemble',
    documentName: 'I want to confirm the interested-activating OU Markets',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-confirm-interest',
    stageUrl: 'https://cokeurl.com/Sxl-confirm-interest',
  },
  {
    phase: 'Assemble',
    documentName: 'I want to assemble the team',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-assemble-the-team',
    stageUrl: 'https://cokeurl.com/Sxl-assemble-the-tea',
  },
  {
    phase: 'Assemble',
    documentName: 'I want to assign the agencies',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-assign-agencies',
    stageUrl: 'https://cokeurl.com/Sxl-assign-agencies',
  },
  {
    phase: 'Assemble',
    documentName: 'I want to assign OU or market project leads',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-ou-mkt-proj-leads',
    stageUrl: 'https://cokeurl.com/Sxl-ou-mkt-proj-lead',
  },
  {
    phase: 'Assemble',
    documentName: 'I want to get approval of Project Blueprint',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-approve-blueprint',
    stageUrl: 'https://cokeurl.com/Sxl-approve-blueprin',
  },
  {
    phase: 'Assemble',
    documentName: 'I want to onboard the team to the project',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-onboard-the-team',
    stageUrl: 'https://cokeurl.com/Sxl-onboard-the-team',
  },
  {
    phase: 'Assemble',
    documentName: 'I want to explore past learnings',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-past-learnings',
    stageUrl: 'https://cokeurl.com/Sxl-past-learnings',
  },
  {
    phase: 'Explore',
    documentName: 'I want to define the Marketing Opportunity Brief',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-define-mo-brief',
    stageUrl: 'https://cokeurl.com/Sxl-define-mo-brief',
  },
  {
    phase: 'Explore',
    documentName: 'I want to create LIT Insights',
    fileType: 'PDF',
    roles: ['Human Insights Lead'],
    prodUrl: 'https://cokeurl.com/xl-creat-lit-insight',
    stageUrl: 'https://cokeurl.com/Sxl-creat-lit-insigh',
  },
  {
    phase: 'Explore',
    documentName: 'I want to create the Experience Architecture',
    fileType: 'PDF',
    roles: ['Experience Lead'],
    prodUrl: 'https://cokeurl.com/xl-create-exp-arch',
    stageUrl: 'https://cokeurl.com/Sxl-create-exp-arch',
  },
  {
    phase: 'Explore',
    documentName: 'I want to define the Learning Plan',
    fileType: 'PDF',
    roles: ['Performance Lead'],
    prodUrl: 'https://cokeurl.com/xl-define-learn-plan',
    stageUrl: 'https://cokeurl.com/Sxl-define-learn-pla',
  },
  {
    phase: 'Explore',
    documentName: 'I want to create the Idea Brief',
    fileType: 'PDF',
    roles: ['Creative Lead'],
    prodUrl: 'https://cokeurl.com/xl-create-idea-brief',
    stageUrl: 'https://cokeurl.com/Sxl-create-idea-brie',
  },
  {
    phase: 'Explore',
    documentName: 'I want to complete the Decision Moment for Explore',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-decision-phase-2',
    stageUrl: 'https://cokeurl.com/Sxl-decision-phase-2',
  },
  {
    phase: 'Explore',
    documentName: 'I want to submit requests for receiving OU-Market projects',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-submit-for-prio',
    stageUrl: 'https://cokeurl.com/Sxl-submit-for-prio',
  },
  {
    phase: 'Create',
    documentName: 'I want to develop Experience Idea Concept',
    fileType: 'PDF',
    roles: ['Creative Lead'],
    prodUrl: 'https://cokeurl.com/xl-dev-idea-concept',
    stageUrl: 'https://cokeurl.com/Sxl-dev-idea-concept',
  },
  {
    phase: 'Create',
    documentName: 'I want to get approval on Experience Idea Concept',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-approve-idea',
    stageUrl: 'https://cokeurl.com/Sxl-approve-idea',
  },
  {
    phase: 'Create',
    documentName: 'I want to test the Experience',
    fileType: 'PDF',
    roles: ['Human Insights Lead'],
    prodUrl: 'https://cokeurl.com/xl-test-experience',
    stageUrl: 'https://cokeurl.com/Sxl-test-experience',
  },
  {
    phase: 'Create',
    documentName: 'I want to create initial network deliverables list',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-create-deliv-list',
    stageUrl: 'https://cokeurl.com/Sxl-create-deliv-lis',
  },
  {
    phase: 'Create',
    documentName: 'I want to create initial shopper strategy',
    fileType: 'PDF',
    roles: ['Customer Lead'],
    prodUrl: 'https://cokeurl.com/xl-init-shop-strat',
    stageUrl: 'https://cokeurl.com/Sxl-init-shop-strat',
  },
  {
    phase: 'Create',
    documentName: 'I want to create feasibility assessment',
    fileType: 'PDF',
    roles: ['Experience Lead'],
    prodUrl: 'https://cokeurl.com/xl-assess-feasible',
    stageUrl: 'https://cokeurl.com/Sxl-assess-feasible',
  },
  {
    phase: 'Create',
    documentName: 'I want to complete the Decision Moment for Create',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-decision-phase-3',
    stageUrl: 'https://cokeurl.com/Sxl-decision-phase-3',
  },
  {
    phase: 'Shape',
    documentName: 'I want to co-create with OUs',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-co-create-plans',
    stageUrl: 'https://cokeurl.com/Sxl-co-create-plans',
  },
  {
    phase: 'Shape',
    documentName: 'I want to create the Content Production and Delivery Plan',
    fileType: 'PDF',
    roles: ['OU Project Leads'],
    prodUrl: 'https://cokeurl.com/xl-shape-deliv-plan',
    stageUrl: 'https://cokeurl.com/Sxl-shape-deliv-plan',
  },
  {
    phase: 'Shape',
    documentName: 'I want to create customer sell-in story',
    fileType: 'PDF',
    roles: ['Customer Lead'],
    prodUrl: 'https://cokeurl.com/xl-create-c-sell-in',
    stageUrl: 'https://cokeurl.com/Sxl-create-c-sell-in',
  },
  {
    phase: 'Shape',
    documentName: 'I want to create the Experience Execution Plan',
    fileType: 'PDF',
    roles: ['OU Project Leads'],
    prodUrl: 'https://cokeurl.com/xl-mkt-exec-plans',
    stageUrl: 'https://cokeurl.com/Sxl-mkt-exec-plans',
  },
  {
    phase: 'Shape',
    documentName: 'I want to implement Experience Performance Tracking',
    fileType: 'PDF',
    roles: ['Performance Lead'],
    prodUrl: 'https://cokeurl.com/xl-performance-track',
    stageUrl: 'https://cokeurl.com/Sxl-performance-trac',
  },
  {
    phase: 'Shape',
    documentName: 'I want to perform pre-flight test',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-pre-flight-tests',
    stageUrl: 'https://cokeurl.com/Sxl-pre-flight-tests',
  },
  {
    phase: 'Shape',
    documentName: 'I want to complete the Decision Moment for Shape',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-decision-phase-4',
    stageUrl: 'https://cokeurl.com/Sxl-decision-phase-4',
  },
  {
    phase: 'Produce',
    documentName: 'I want to align on production plans',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-align-prod-plans',
    stageUrl: 'https://cokeurl.com/Sxl-align-prod-plans',
  },
  {
    phase: 'Produce',
    documentName: 'I want to get approval of production plans',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-approv-prod-plans',
    stageUrl: 'https://cokeurl.com/Sxl-approv-prod-plan',
  },
  {
    phase: 'Produce',
    documentName: 'I want to produce Shopper & Commerce Experience Toolkit',
    fileType: 'PDF',
    roles: ['Customer Lead'],
    prodUrl: 'https://cokeurl.com/xl-prod-shoppr-tlkit',
    stageUrl: 'https://cokeurl.com/Sxl-prod-shoppr-tlki',
  },
  {
    phase: 'Produce',
    documentName: 'I want to produce the EPICS Experience Toolkit',
    fileType: 'PDF',
    roles: ['EPICS Lead'],
    prodUrl: 'https://cokeurl.com/xl-get-input-epics',
    stageUrl: 'https://cokeurl.com/Sxl-get-input-epics',
  },
  {
    phase: 'Produce',
    documentName: 'I want to produce the Design Experience Toolkit',
    fileType: 'PDF',
    roles: ['Design Lead'],
    prodUrl: 'https://cokeurl.com/xl-get-input-imx-des',
    stageUrl: 'https://cokeurl.com/Sxl-get-input-imx-de',
  },
  {
    phase: 'Produce',
    documentName: 'I want to produce the Blueprint Digital Experience Toolkit & Data Strategy',
    fileType: 'PDF',
    roles: ['Digital Lead'],
    prodUrl: 'https://cokeurl.com/xl-get-input-imx-dig',
    stageUrl: 'https://cokeurl.com/Sxl-get-input-imx-di',
  },
  {
    phase: 'Produce',
    documentName: 'I want to produce the Creative Experience Toolkit with Media Guidelines',
    fileType: 'PDF',
    roles: ['Creative Lead'],
    prodUrl: 'https://cokeurl.com/xl-get-input-agency',
    stageUrl: 'https://cokeurl.com/Sxl-get-input-agency',
  },
  {
    phase: 'Produce',
    documentName: 'I want to localize the Assets and Toolkits',
    fileType: 'PDF',
    roles: ['OU Project Leads'],
    prodUrl: 'https://cokeurl.com/xl-mkt-spec-toolkit',
    stageUrl: 'https://cokeurl.com/Sxl-mkt-spec-toolkit',
  },
  {
    phase: 'Produce',
    documentName: 'I want to get approval on Localized Assets & Toolkits',
    fileType: 'PDF',
    roles: ['OU Project Leads'],
    prodUrl: 'https://cokeurl.com/xl-apprv-mkt-toolkit',
    stageUrl: 'https://cokeurl.com/Sxl-apprv-mkt-toolki',
  },
  {
    phase: 'Produce',
    documentName: 'I want to upload Assets & Toolkits to KO Assets',
    fileType: 'PDF',
    roles: ['OU Project Leads'],
    prodUrl: 'https://cokeurl.com/xl-assets-into-dam',
    stageUrl: 'https://cokeurl.com/Sxl-assets-into-dam',
  },
  {
    phase: 'Produce',
    documentName: 'I want to perform pre-flight Experience Test and Learn',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-pre-flight-xtests',
    stageUrl: 'https://cokeurl.com/Sxl-pre-flight-xtest',
  },
  {
    phase: 'Produce',
    documentName: 'I want to complete the Decision Moment for Produce',
    fileType: 'PDF',
    roles: ['OU Project Leads'],
    prodUrl: 'https://cokeurl.com/xl-decision-phase-5',
    stageUrl: 'https://cokeurl.com/Sxl-decision-phase-5',
  },
  {
    phase: 'Learn',
    documentName: 'I want to do In-flight Optimization',
    fileType: 'PDF',
    roles: ['OU Project Leads'],
    prodUrl: 'https://cokeurl.com/xl-optimize-exec',
    stageUrl: 'https://cokeurl.com/Sxl-optimize-exec',
  },
  {
    phase: 'Learn',
    documentName: 'I want to do an After Action Review',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-prep-after-action',
    stageUrl: 'https://cokeurl.com/Sxl-prep-after-actio',
  },
  {
    phase: 'Learn',
    documentName: 'I want to do the project offboarding',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/xl-proj-offboarding',
    stageUrl: 'https://cokeurl.com/Sxl-proj-offboarding',
  },
]

export const innovationDocuments = [
  {
    phase: 'Project Request',
    documentName: 'I want to create an Innovation project',
    fileType: 'PDF',
    roles: ['All Roles'],
    prodUrl: 'https://cokeurl.com/in-create-in-project',
    stageUrl: 'https://cokeurl.com/Sin-create-in-projec',
  },
  {
    phase: 'Project Request',
    documentName: 'I want to create a Single Market Innovation Project',
    fileType: 'PDF',
    roles: ['All Roles'],
    prodUrl: 'https://cokeurl.com/in-creat-single-proj',
    stageUrl: 'https://cokeurl.com/Sin-creat-single-pro',
  },
  {
    phase: 'Strategy to Idea',
    documentName: 'I want to resource and adjust the project schedule',
    fileType: 'PDF',
    roles: ['Initiative Lead'],
    prodUrl: 'https://cokeurl.com/in-resource-project',
    stageUrl: 'https://cokeurl.com/Sin-resource-project',
  },
  {
    phase: 'Strategy to Idea',
    documentName: 'I want to complete Consumer Desirability',
    fileType: 'PDF',
    roles: ['Human Insights'],
    prodUrl: 'https://cokeurl.com/in-consumer-desire',
    stageUrl: 'https://cokeurl.com/Sin-consumer-desire',
  },
  {
    phase: 'Strategy to Idea',
    documentName: 'I want to complete a Financial Viability T-Print',
    fileType: 'PDF',
    roles: ['Finance'],
    prodUrl: 'https://cokeurl.com/in-fin-viability',
    stageUrl: 'https://cokeurl.com/Sin-fin-viability',
  },
  {
    phase: 'Strategy to Idea',
    documentName: 'I want to complete a Technical Feasibility T-Print',
    fileType: 'PDF',
    roles: ['Research & Development', 'Technical Commercialization/Operations', 'Technical Consumer Research'],
    prodUrl: 'https://cokeurl.com/in-tech-feasible',
    stageUrl: 'https://cokeurl.com/Sin-tech-feasible',
  },
  {
    phase: 'Strategy to Idea',
    documentName: 'I want to complete Unified Prioritization Form Innovation',
    fileType: 'PDF',
    roles: ['Initiative Lead'],
    prodUrl: 'https://cokeurl.com/in-comp-proj-details',
    stageUrl: 'https://cokeurl.com/Sin-comp-proj-detail',
  },
  {
    phase: 'Strategy to Idea',
    documentName: 'I want to request alignment and prepare for Gate 1',
    fileType: 'PDF',
    roles: ['Initiative Lead'],
    prodUrl: 'https://cokeurl.com/in-prep-for-gate-1',
    stageUrl: 'https://cokeurl.com/Sin-prep-for-gate-1',
  },
  {
    phase: 'Strategy to Idea',
    documentName: 'I want to complete Gate 1 Pipeline Prioritization and Approval',
    fileType: 'PDF',
    roles: ['Innovation Global PMO Team'],
    prodUrl: 'https://cokeurl.com/in-gate-1-approval',
    stageUrl: 'https://cokeurl.com/Sin-gate-1-approval',
  },
  {
    phase: 'Develop Concept & Business Case',
    documentName: 'I want to do project kick-off and update plan',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-kickoff-plan-s2',
    stageUrl: 'https://cokeurl.com/Sin-kickoff-plan-s2',
  },
  {
    phase: 'Develop Concept & Business Case',
    documentName: 'I want to assess and validate concepts',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-validate-concept',
    stageUrl: 'https://cokeurl.com/Sin-validate-concept',
  },
  {
    phase: 'Develop Concept & Business Case',
    documentName: 'I want to complete briefs in product info',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-brief-prod-info',
    stageUrl: 'https://cokeurl.com/Sin-brief-prod-info',
  },
  {
    phase: 'Develop Concept & Business Case',
    documentName: 'I want to create the preliminary business case',
    fileType: 'PDF',
    roles: ['Finance'],
    prodUrl: 'https://cokeurl.com/in-prelim-bus-case',
    stageUrl: 'https://cokeurl.com/Sin-prelim-bus-case',
  },
  {
    phase: 'Develop Concept & Business Case',
    documentName: 'I want to complete Technical Feasibility risk assessment Gate 2',
    fileType: 'PDF',
    roles: [
      'Commercial Products Supply',
      'Packaging Graphics',
      'Research & Development',
      'Scientific & Regulatory Affairs',
      'Technical Commercialization/Operations',
      'Technical Consumer Research',
    ],
    prodUrl: 'https://cokeurl.com/in-risk-assess-g2',
    stageUrl: 'https://cokeurl.com/Sin-risk-assess-g2',
  },
  {
    phase: 'Develop Concept & Business Case',
    documentName: 'I want to request alignment and prepare Gate 2',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-prep-for-gate-2',
    stageUrl: 'https://cokeurl.com/Sin-prep-for-gate-2',
  },
  {
    phase: 'Develop Concept & Business Case',
    documentName: 'I want to complete Gate 2 Decision to Develop Solutions',
    fileType: 'PDF',
    roles: ['PMO'],
    prodUrl: 'https://cokeurl.com/in-gate-2-decision',
    stageUrl: 'https://cokeurl.com/Sin-gate-2-decision',
  },
  {
    phase: 'Solution Development',
    documentName: 'I want to refine and update project plan Stage 3',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-refine-plan-s3',
    stageUrl: 'https://cokeurl.com/Sin-refine-plan-s3',
  },
  {
    phase: 'Solution Development',
    documentName: 'I want to develop the solution',
    fileType: 'PDF',
    roles: ['Project Lead', 'R&D Local'],
    prodUrl: 'https://cokeurl.com/in-develop-solution',
    stageUrl: 'https://cokeurl.com/Sin-develop-solution',
  },
  {
    phase: 'Solution Development',
    documentName: 'I want to test and validate the solution',
    fileType: 'PDF',
    roles: ['Human Insights', 'Project Lead'],
    prodUrl: 'https://cokeurl.com/in-test-and-validate',
    stageUrl: 'https://cokeurl.com/Sin-test-and-validat',
  },
  {
    phase: 'Solution Development',
    documentName: 'I want to confirm technical and commercialization approach',
    fileType: 'PDF',
    roles: [
      'Bottler',
      'Commercial Products Supply',
      'Quality Assurance',
      'Research & Development',
      'Scientific & Regulatory Affairs',
      'Supply Chain',
      'Technical Commercialization/Operations',
      'Technical Consumer Research',
    ],
    prodUrl: 'https://cokeurl.com/in-confirm-approach',
    stageUrl: 'https://cokeurl.com/Sin-confirm-approach',
  },
  {
    phase: 'Solution Development',
    documentName: 'I want to refine the business case',
    fileType: 'PDF',
    roles: ['Finance'],
    prodUrl: 'https://cokeurl.com/in-refine-bus-case',
    stageUrl: 'https://cokeurl.com/Sin-refine-bus-case',
  },
  {
    phase: 'Solution Development',
    documentName: 'I want to complete Technical Feasibility risk assessment Gate 3',
    fileType: 'PDF',
    roles: [
      'Commercial Products Supply',
      'Research & Development',
      'Scientific & Regulatory Affairs',
      'Technical Commercialization/Operations',
      'Technical Consumer Research',
    ],
    prodUrl: 'https://cokeurl.com/in-risk-assess-g3',
    stageUrl: 'https://cokeurl.com/Sin-risk-assess-g3',
  },
  {
    phase: 'Solution Development',
    documentName: 'I want to request alignment and prepare Gate 3',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-prep-for-gate-3',
    stageUrl: 'https://cokeurl.com/Sin-prep-for-gate-3',
  },
  {
    phase: 'Solution Development',
    documentName: 'I want to complete Gate 3 Decision to Launch',
    fileType: 'PDF',
    roles: ['PMO'],
    prodUrl: 'https://cokeurl.com/in-gate-3-decision',
    stageUrl: 'https://cokeurl.com/Sin-gate-3-decision',
  },
  {
    phase: 'Launch Preparation',
    documentName: 'I want to refine and update project plan Stage 4',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-refine-plan-s4',
    stageUrl: 'https://cokeurl.com/Sin-refine-plan-s4',
  },
  {
    phase: 'Launch Preparation',
    documentName: 'I want to do the trade sell-in',
    fileType: 'PDF',
    roles: ['Bottler'],
    prodUrl: 'https://cokeurl.com/in-trade-sell-in',
    stageUrl: 'https://cokeurl.com/Sin-trade-sell-in',
  },
  {
    phase: 'Launch Preparation',
    documentName: 'I want to implement new capabilities CAPEX',
    fileType: 'PDF',
    roles: ['Bottler SC'],
    prodUrl: 'https://cokeurl.com/in-implement-new-cap',
    stageUrl: 'https://cokeurl.com/Sin-implement-new-ca',
  },
  {
    phase: 'Launch Preparation',
    documentName: 'I want to do graphics production',
    fileType: 'PDF',
    roles: ['Packaging Graphics'],
    prodUrl: 'https://cokeurl.com/in-graphics-prod',
    stageUrl: 'https://cokeurl.com/Sin-graphics-prod',
  },
  {
    phase: 'Launch Preparation',
    documentName: 'I want to order raw materials',
    fileType: 'PDF',
    roles: ['Bottler SC', 'Technical Commercialization/Operations'],
    prodUrl: 'https://cokeurl.com/in-order-raw-mats',
    stageUrl: 'https://cokeurl.com/Sin-order-raw-mats',
  },
  {
    phase: 'Launch Preparation',
    documentName: 'I want to finalize product plan',
    fileType: 'PDF',
    roles: ['Bottler ', 'Bottler SC'],
    prodUrl: 'https://cokeurl.com/in-final-prod-plan',
    stageUrl: 'https://cokeurl.com/Sin-final-prod-plan',
  },
  {
    phase: 'Launch Preparation',
    documentName: 'I want to finalize distribution plan',
    fileType: 'PDF',
    roles: ['Bottler ', 'Bottler SC'],
    prodUrl: 'https://cokeurl.com/in-final-dist-plan',
    stageUrl: 'https://cokeurl.com/Sin-final-dist-plan',
  },
  {
    phase: 'Launch Preparation',
    documentName: 'I want to finalize market launch plan',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-final-launch-plan',
    stageUrl: 'https://cokeurl.com/Sin-final-launch-pla',
  },
  {
    phase: 'Launch Preparation',
    documentName: 'I want to confirm the business case and metrics',
    fileType: 'PDF',
    roles: ['Finance', 'Project Lead'],
    prodUrl: 'https://cokeurl.com/in-confirm-metrics',
    stageUrl: 'https://cokeurl.com/Sin-confirm-metrics',
  },
  {
    phase: 'Launch Preparation',
    documentName: 'I want to complete Technical Feasibility risk assessment Gate 4',
    fileType: 'PDF',
    roles: [
      'Commercial Products Supply',
      'Research & Development',
      'Scientific & Regulatory Affairs',
      'Technical Commercialization/Operations',
      'Technical Consumer Research',
    ],
    prodUrl: 'https://cokeurl.com/in-risk-assess-g4',
    stageUrl: 'https://cokeurl.com/Sin-risk-assess-g4',
  },
  {
    phase: 'Launch Preparation',
    documentName: 'I want to request alignment and prepare Gate 4',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-prep-for-gate-4',
    stageUrl: 'https://cokeurl.com/Sin-prep-for-gate-4',
  },
  {
    phase: 'Launch Preparation',
    documentName: 'I want to complete Gate 4 Decision to Produce',
    fileType: 'PDF',
    roles: ['PMO'],
    prodUrl: 'https://cokeurl.com/in-gate-4-decision',
    stageUrl: 'https://cokeurl.com/Sin-gate-4-decision',
  },
  {
    phase: 'Market Execution',
    documentName: 'I want to refine and update project plan Stage 5',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-refine-plan-s5',
    stageUrl: 'https://cokeurl.com/Sin-refine-plan-s5',
  },
  {
    phase: 'Market Execution',
    documentName: 'I want to implement launch tracking',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-launch-tracking',
    stageUrl: 'https://cokeurl.com/Sin-launch-tracking',
  },
  {
    phase: 'Market Execution',
    documentName: 'I want to prepare 1st production',
    fileType: 'PDF',
    roles: ['Bottler SC'],
    prodUrl: 'https://cokeurl.com/in-prep-1st-prod',
    stageUrl: 'https://cokeurl.com/Sin-prep-1st-prod',
  },
  {
    phase: 'Market Execution',
    documentName: 'I want to do 1st production',
    fileType: 'PDF',
    roles: ['Bottler SC'],
    prodUrl: 'https://cokeurl.com/in-1st-production',
    stageUrl: 'https://cokeurl.com/Sin-1st-production',
  },
  {
    phase: 'Market Execution',
    documentName: 'I want to do distribution',
    fileType: 'PDF',
    roles: ['Bottler SC'],
    prodUrl: 'https://cokeurl.com/in-distribution',
    stageUrl: 'https://cokeurl.com/Sin-distribution',
  },
  {
    phase: 'Market Execution',
    documentName: 'I want to do in-market launch',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-in-market-launch',
    stageUrl: 'https://cokeurl.com/Sin-in-market-launch',
  },
  {
    phase: 'Market Execution',
    documentName: 'I want to execute plan and track',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-exec-plan-track',
    stageUrl: 'https://cokeurl.com/Sin-exec-plan-track',
  },
  {
    phase: 'Market Execution',
    documentName: 'I want to do 3rd month tracking',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-3m-track',
    stageUrl: 'https://cokeurl.com/Sin-3m-track',
  },
  {
    phase: 'Market Execution',
    documentName: 'I want to do 6th month tracking and review',
    fileType: 'PDF',
    roles: ['Project Lead'],
    prodUrl: 'https://cokeurl.com/in-6m-track-review',
    stageUrl: 'https://cokeurl.com/Sin-6m-track-review',
  },
  {
    phase: 'Market Execution',
    documentName: 'I want to complete Technical Feasibility risk assessment Gate 5',
    fileType: 'PDF',
    roles: ['Research & Development', 'Scientific & Regulatory Affairs', 'Technical Commercialization/Operations'],
    prodUrl: 'https://cokeurl.com/in-risk-assess-g5',
    stageUrl: 'https://cokeurl.com/Sin-risk-assess-g5',
  },
  {
    phase: 'Market Execution',
    documentName: 'I want to complete Gate 5 - PLR & Recommendations to Scale',
    fileType: 'PDF',
    roles: ['PMO'],
    prodUrl: 'https://cokeurl.com/in-prep-to-scale',
    stageUrl: 'https://cokeurl.com/Sin-prep-to-scale',
  },
]

export const persistentPlatfromDocuments = [
  {
    phase: 'Lens Toolkits',
    documentName: '01 The Indulgent Lens',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 01 The Indulgent Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '02 The Adventurous Lens',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 02 The Adventurous Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '03 The Supercharged Lens',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 03 The Supercharged Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '04 The Scientific Lens',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 04 The Scientific Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '05 The Better-For-You Lens',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 05 The Better-For-You Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '06 The Natural Lens',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 06 The Natural Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '07 The Grounded Lens',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 07 The Grounded Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '08 The Artisanal Lens',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 08 The Artisanal Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '01 The Indulgent Lens',
    fileType: 'MP4',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 01 The Indulgent Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '02 The Adventurous Lens',
    fileType: 'MP4',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 02 The Adventurous Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '03 The Supercharged Lens',
    fileType: 'MP4',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 03 The Supercharged Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '04 The Scientific Lens',
    fileType: 'MP4',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 04 The Scientific Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '05 The Better-For-You Lens',
    fileType: 'MP4',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 05 The Better-For-You Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '06 The Natural Lens',
    fileType: 'MP4',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 06 The Natural Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '07 The Grounded Lens',
    fileType: 'MP4',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 07 The Grounded Lens.pdf'),
  },
  {
    phase: 'Lens Toolkits',
    documentName: '08 The Artisanal Lens',
    fileType: 'MP4',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - 08 The Artisanal Lens.pdf'),
  },
  {
    phase: 'Other Materials',
    documentName: 'Creative methods',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - Creative methods.pdf'),
  },
  {
    phase: 'Other Materials',
    documentName: 'MoT Driving Trial',
    fileType: 'PDF',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - MoT Driving Trial.pdf'),
  },
  {
    phase: 'Other Materials',
    documentName: 'Semiotics of Exceptional Taste  Sensorial  Experiences (Semiovox) Jan 2024',
    fileType: 'PDF',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - Semiotics of Exceptional Taste  Sensorial  Experiences (Semiovox) Jan 2024.pdf'),
  },
  {
    phase: 'Other Materials',
    documentName: 'VIS Measurement Project',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - VIS Measurement Project.pdf'),
  },
  {
    phase: 'Other Materials',
    documentName: 'Shelf Ready Packaging',
    fileType: 'PDF',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - Shelf Ready Packaging.pdf'),
  },
  {
    phase: 'Other Materials',
    documentName: 'Lenses VIS Full Cases Deck',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - Lenses VIS Full Cases Deck.pdf'),
  },
  {
    phase: 'Need States',
    documentName: 'Needstate Audit_Balance',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - Needstate Audit_Balance.pdf'),
  },
  {
    phase: 'Need States',
    documentName: 'Needstate Audit_Fuel',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - Needstate Audit_Fuel.pdf'),
  },
  {
    phase: 'Need States',
    documentName: 'Needstate Audit_Enhance',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - Needstate Audit_Enhance.pdf'),
  },
  {
    phase: 'Need States',
    documentName: 'Needstate Audit_Delight',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - Needstate Audit_Delight.pdf'),
  },
  {
    phase: 'Need States',
    documentName: 'Needstate Audit_Escape & Socialisation',
    fileType: 'PPTX',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'persistentplatform', 'WF - Needstate Audit_Escape & Socialisation.pdf'),
  },
]

export const brtieDocuments = [
  {
    phase: 'Training',
    documentName: 'WF - BRITE are in perfect sync',
    fileType: 'PDF',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'brite', 'WF - BRITE are in perfect sync.pdf'),
  },
  {
    phase: 'FAQS',
    documentName: 'BRITE & Workfront FAQs',
    fileType: 'PDF',
    roles: ['All Roles'],
    url: buildFacadeFileUrl(facadeURL, 'brite', 'BRITE & Workfront FAQs.pdf'),
  },
]

export const roles = [
  { value: 'All Roles', label: 'All Roles' },
  { value: 'Bottler', label: 'Bottler' },
  { value: 'Bottler SC', label: 'Bottler SC' },
  { value: 'Commercial Products Supply', label: 'Commercial Products Supply' },
  { value: 'Creative Lead', label: 'Creative Lead' },
  { value: 'Customer Lead', label: 'Customer Lead' },
  { value: 'Design Lead', label: 'Design Lead' },
  { value: 'Digital Lead', label: 'Digital Lead' },
  { value: 'EPICS Lead', label: 'EPICS Lead' },
  { value: 'Experience Lead', label: 'Experience Lead' },
  { value: 'Finance', label: 'Finance' },
  { value: 'Human Insights', label: 'Human Insights' },
  { value: 'Human Insights Lead', label: 'Human Insights Lead' },
  { value: 'Initiative Lead', label: 'Initiative Lead' },
  { value: 'Innovation Global PMO Team', label: 'Innovation Global PMO Team' },
  { value: 'OU Project Leads', label: 'OU Project Leads' },
  { value: 'PMO', label: 'PMO' },
  { value: 'Packaging Graphics', label: 'Packaging Graphics' },
  { value: 'Performance Lead', label: 'Performance Lead' },
  { value: 'Project Lead', label: 'Project Lead' },
  { value: 'Project Owner', label: 'Project Owner' },
  { value: 'Quality Assurance', label: 'Quality Assurance' },
  { value: 'R&D Local', label: 'R&D Local' },
  { value: 'Research & Development', label: 'Research & Development' },
  { value: 'Scientific & Regulatory Affairs', label: 'Scientific & Regulatory Affairs' },
  { value: 'Supply Chain', label: 'Supply Chain' },
  { value: 'Technical Commercialization/Operations', label: 'Technical Commercialization/Operations' },
  { value: 'Technical Consumer Research', label: 'Technical Consumer Research' },
  { value: 'Technical Lead', label: 'Technical Lead' },
]
